import { camelCase } from 'lodash'

export const createIcon = (...items: string[]) =>
  `islands#${camelCase(items.map((item) => item.toLowerCase()).join('-'))}`
